// Network validators for BTC / TRX / ETH / BSC.
// All checks are tri-state aware: 'idle' | 'valid' | 'invalid' | 'incomplete'.

import { validateBTC } from "./btc";

const TRX_RE = /^T[a-km-zA-HJ-NP-Z1-9]{33}$/;
const EVM_FULL_RE = /^0x[a-fA-F0-9]{40}$/;
const TRX_CHARS = /^[Ta-km-zA-HJ-NP-Z1-9]+$/;
const HEX_PREFIX_RE = /^0x[a-fA-F0-9]*$/;

function idle(charCount = 0) {
  return { status: "idle", charCount, message: "" };
}

function validateTRX(input) {
  const addr = (input || "").trim();
  const len = addr.length;
  if (len === 0) return idle();
  if (addr[0] !== "T") {
    return { status: "invalid", charCount: len, message: "Must start with T" };
  }
  if (!TRX_CHARS.test(addr)) {
    return { status: "invalid", charCount: len, message: "Invalid character" };
  }
  if (len < 34) return { status: "incomplete", charCount: len, message: "Address incomplete" };
  if (len > 34) return { status: "invalid", charCount: len, message: "Address too long" };
  return TRX_RE.test(addr)
    ? { status: "valid", charCount: len, message: "Valid TRON address" }
    : { status: "invalid", charCount: len, message: "Invalid format" };
}

function validateEVM(input, label) {
  const addr = (input || "").trim();
  const len = addr.length;
  if (len === 0) return idle();
  if (!addr.startsWith("0x") && !addr.startsWith("0X")) {
    return { status: "invalid", charCount: len, message: 'Must start with "0x"' };
  }
  if (!HEX_PREFIX_RE.test(addr)) {
    return { status: "invalid", charCount: len, message: "Invalid hex character" };
  }
  if (len < 42) return { status: "incomplete", charCount: len, message: "Address incomplete" };
  if (len > 42) return { status: "invalid", charCount: len, message: "Address too long" };
  return EVM_FULL_RE.test(addr)
    ? { status: "valid", charCount: len, message: `Valid ${label} address` }
    : { status: "invalid", charCount: len, message: "Invalid format" };
}

export const NETWORKS = [
  {
    id: "btc",
    label: "BITCOIN",
    symbol: "BTC",
    explorer: (addr) => `https://www.blockchain.com/explorer/addresses/btc/${addr}`,
    validate: (addr) => validateBTC(addr),
  },
  {
    id: "trx",
    label: "TRON",
    symbol: "TRX",
    explorer: (addr) => `https://tronscan.org/#/address/${addr}`,
    validate: (addr) => validateTRX(addr),
  },
  {
    id: "eth",
    label: "ETHEREUM",
    symbol: "ETH",
    explorer: (addr) => `https://etherscan.io/address/${addr}`,
    validate: (addr) => validateEVM(addr, "Ethereum"),
  },
  {
    id: "bsc",
    label: "BNB SMART CHAIN",
    symbol: "BSC",
    explorer: (addr) => `https://bscscan.com/address/${addr}`,
    validate: (addr) => validateEVM(addr, "BNB Smart Chain"),
  },
];

export function validateAddress(address) {
  const trimmed = (address || "").trim();
  const results = {};
  for (const net of NETWORKS) {
    results[net.id] = trimmed.length === 0 ? { status: "idle", charCount: 0 } : net.validate(trimmed);
  }
  return results;
}

export function getMatchedNetworks(results) {
  return NETWORKS.filter((n) => results[n.id]?.status === "valid").map((n) => n.symbol);
}
